import { Skeleton, TableCell, TableRow } from "@mui/material";
import React from "react";

export const TableRowsSkeleton = ({
  rowsNum,
  columnsNum,
}: {
  rowsNum: number;
  columnsNum: number;
}) => {
  return [...Array(rowsNum)].map((_, rowIndex) => (
    <TableRow key={rowIndex}>
      {[...Array(columnsNum)].map((_, colIndex) => (
        <TableCell key={colIndex}>
          <Skeleton animation="wave" variant="text" />
        </TableCell>
      ))}
    </TableRow>
  ));
};
